import { useState } from 'react';
import { Skeleton } from '@mui/material';

interface ImageItemProps {
    alt: string;
    className: string;
    onClick: () => void;
    src: string;
}

export const ImageItem = (props: ImageItemProps) => {
    const { alt, className, onClick, src } = props;

    const [hasLoaded, setHasLoaded] = useState(false);

    return (
        <>
            {!hasLoaded && <Skeleton className={className} data-testid="loadingSkeleton" variant="rectangular" />}
            <img alt={alt} className={className} onClick={onClick} onLoad={() => setHasLoaded(true)} src={src} />
        </>
    );
};
